import fetcher from 'api/fetcher';
import { resolvePromisesMap } from 'utils/clickme';

import { RequisitesData, requisitesDataFromDto } from 'components/RequisitesFormModal/requisitesMapper';

import { setExistAdvertisingCampaigns } from 'store/autoReducers';
import type { Action } from 'store/createReducer';
import { RequisitesPayer, setAllRequisites, setRequisitesFilled, setRequisitesPayers } from 'store/models/requisites';
import { AppThunkAction } from 'store/utils';

interface PayersData {
    payers: RequisitesPayer[];
}

interface ExistAdvertisingCampaignsData {
    existAdvertisingCampaigns: boolean;
}

type FetchRequisites = (
    setLoading: (isLoading: boolean) => void,
    setRequisitesEditable: (isRequisitesEditable: boolean) => void
) => AppThunkAction;

export const fetchRequisites: FetchRequisites = (setLoading, setRequisitesEditable) => {
    return (dispatch) => {
        setLoading(true);
        return resolvePromisesMap({
            requisitesData: [fetcher.get<unknown, RequisitesData>('/api/v1/requisites')],
            existAdvertisingCampaignsData: [
                fetcher.get<unknown, ExistAdvertisingCampaignsData>('/api/v1/campaigns/exist_advertising_campaigns'),
            ],
        })
            .then(async ({ requisitesData, existAdvertisingCampaignsData }) => {
                const requisites = requisitesData[0];
                const { isRequisitesEditable, finalAdvertiserRequisites } = requisites;
                const { existAdvertisingCampaigns } = existAdvertisingCampaignsData[0];
                const actions: Action[] = [];

                setRequisitesEditable(isRequisitesEditable);

                if (existAdvertisingCampaigns) {
                    actions.push(setExistAdvertisingCampaigns(existAdvertisingCampaigns));
                }

                if (!finalAdvertiserRequisites) {
                    const { payers } = await fetcher.get<unknown, PayersData>('/api/v1/requisites/payers');
                    actions.push(setRequisitesPayers(payers));
                } else {
                    actions.push(setRequisitesFilled(true));
                    actions.push(setAllRequisites(requisitesDataFromDto(requisites)));
                }

                dispatch(actions);
            })
            .finally(() => setLoading(false));
    };
};
